const event_msg_keys = {
	image_upload_progress:'image_upload_progress',
	image_upload_success:'image_upload_success',
	image_upload_fail:'image_upload_fail',
	video_upload_success:'video_upload_success',
	video_upload_fail:'video_upload_fail',
	video_upload_progress:'video_upload_progress',
	video_upload_cancel:'video_upload_cancel',
	msg_send_success:'msg_send_success',
	msg_send_fail:'msg_send_fail',
	emoj_selected_event_noti:'emoj_selected_event_noti',
	text_delete_event_noti:'text_delete_event_noti',
	msg_read_status_update_event_noti:'msg_read_status_update_event_noti',
	rc_connected_event_noti:'rc_connected_event_noti',
	img_selected_submit_noti:'img_selected_submit_noti'
}

export {
	event_msg_keys
}
